import Vue from 'vue'
import App from './App.vue'
import './plugins'
import { domain, clientId } from '../auth_config.json';
import { Auth0Plugin } from './auth';
import router from './router';

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
